import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import Color from '../../Color.js';
import chroma from '../../chroma.js';
import { type } from '../../utils/index.js';
import input from '../input.js';
import hex2rgb from './hex2rgb.js';
import rgb2hex from './rgb2hex.js';
Color.prototype.hex = function (mode) {
  return rgb2hex(this._rgb, mode);
};
var hex = function hex() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['hex']));
};
chroma.hex = hex;
input.format.hex = hex2rgb;
input.autodetect.push({
  p: 4,
  test: function test(h) {
    if (!(arguments.length <= 1 ? 0 : arguments.length - 1) && type(h) === 'string' && [3, 4, 5, 6, 7, 8, 9].indexOf(h.length) >= 0) {
      return 'hex';
    }
  }
});
export { hex };